import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1120px;
  margin: 50px auto 100px auto;
  padding: 0.5em 1em;
`;

export const Content = styled.div`
  background-color: #ffeba3;
  width: 260px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 400px;
  padding: 20px;
  margin: 0 auto;
  border-radius: 16px;
  gap: 90px;

  @media (max-width: 1023px) {
    width: 300px;
  }
`;

export const AlignButton = styled.div`
  margin: 0 auto;
  button {
    box-shadow: none;
  }
`;

export const ContentText = styled.div`
  display: grid;
  gap: 18px;
  position: relative;
  z-index: 999;
  strong,
  p {
    font-family: 'Inter', sans-serif;
    color: #0000c9;
  }

  p {
    font-size: 16px;
    margin-bottom: 8px;
  }

  strong {
    font-size: 28px;
  }

  @media (max-width: 768px) {
    gap: 12px;

    strong {
      font-size: 24px;
      line-height: 1.2;
    }

    p {
      font-size: 14px;
      line-height: 1.4;
    }
  }

  @media (max-width: 425px) {
    gap: 10px;

    strong {
      font-size: 22px;
      line-height: 1.3;
    }

    p {
      font-size: 13px;
      line-height: 1.5;
    }
  }
`;

export const RoundButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffc700;
  border: none;
  font-weight: bold;
  cursor: pointer;
  p {
    color: #0000c9;
    font-size: 18px;
  }

  &:before {
    content: none;
  }
  &:hover {
    background-color: #ffe589;
  }
`;

export const ContainerText = styled.div`
  text-align: center;
  padding: 60px 0 30px 0;
  font-family: 'Inter', sans-serif;
  strong {
    font-weight: bold;
  }
  @media (max-width: 425px) {
    padding: 10px 0 30px 0;

    p {
      font-size: 18px;
    }
  }
`;

export const ContentItem = styled.div`
  border-radius: 16px;
  position: relative;
  padding: 0 5px;

  &::before {
    content: '${(props) => props.number}';
    font-family: 'Inter', sans-serif;
    position: absolute;
    top: 30%;
    left: ${({ number }) => (number === '10' ? 50 : 70)}%;
    transform: translate(-50%, -50%);
    font-size: 14em;

    font-weight: bold;
    color: #ffc700;
    z-index: 0;
    pointer-events: none;
    opacity: 0.3;

    @media (max-width: 1024px) {
      top: 20%;
      font-size: 200px;
    }

    @media (max-width: 768px) {
      font-size: 150px;
      top: 25%;
    }
  }
`;

export const ContainerMobile = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 1em;

  scrollbar-width: none;

  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ContentItemMobile = styled.div`
  border-radius: 16px;
  position: relative;
  padding: 0 5px;

  &::before {
    content: '${(props) => props.number}';
    font-family: 'Inter', sans-serif;
    position: absolute;
    top: 30%;
    left: ${({ number }) => (number === '10' ? 50 : 70)}%;
    transform: translate(-50%, -50%);
    font-size: 14em;
    font-weight: bold;
    color: #ffc700;
    z-index: 0;
    pointer-events: none;
    opacity: 0.3;
  }
`;

export const ContentMobile = styled.div`
  background-color: #ffeba3;
  width: 242px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 400px;
  padding: 20px;
  margin: 0 auto;
  border-radius: 16px;
  gap: 90px;

  @media (max-width: 320px) {
    width: 190px;
  }
`;
